import {
  SET_SELECTED_REQUEST_ID,
  SET_REQUEST_DRAWER_VISIBLE,
} from '../actions/requestCardActions';

const initialState = { selectedRequestId: null, requestDrawerVisible: false };

const requestCardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SELECTED_REQUEST_ID:
      return {
        ...state,
        selectedRequestId: payload,
      };
    case SET_REQUEST_DRAWER_VISIBLE:
      return {
        ...state,
        requestDrawerVisible: payload,
      };
    default:
      return state;
  }
};

export default requestCardReducer;
